import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect, useState, useRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import devWarning from './devwarning';
/**
 * @description 点击指定区域外执行回调
 *
 * @export
 * @param {RefObject<HTMLElement>[]} refs
 * @param {(e: Event) => void} handler
 */

export function useOnClickOutside(refs, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      var _iterator = _createForOfIteratorHelper(refs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ref = _step.value;

          if (!ref.current || ref.current.contains(event.target)) {
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler]);
}
/**
 * @description 合并状态
 *
 * @export
 * @template T
 * @template R
 * @param {(T | (() => T))} defaultStateValue
 * @param {({
 *     defaultValue?: T | (() => T)
 *     value?: T
 *     onChange?: (value: T, prevValue: T) => void
 *     postState?: (value: T) => T
 *   })} [option]
 * @returns {[R, (value: T) => void]}
 */

export function useMergedState(defaultStateValue, // 初始state
option) {
  var _ref = option || {},
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      onChange = _ref.onChange,
      postState = _ref.postState;

  var _useState = useState(function () {
    if (value !== undefined) {
      return value;
    }

    if (defaultValue !== undefined) {
      return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
    }

    return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  var mergedValue = value !== undefined ? value : innerValue;

  if (postState) {
    mergedValue = postState(mergedValue);
  }

  function triggerChange(newValue) {
    setInnerValue(newValue);

    if (mergedValue !== newValue && onChange) {
      onChange(newValue, mergedValue);
    }
  }

  var firstRenderRef = useRef(true);
  useEffect(function () {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }

    if (value === undefined) {
      setInnerValue(value);
    }
  }, [value]);
  return [mergedValue, triggerChange];
}
/**
 * @description 获取之前的值
 *
 * @export
 * @param {P} value
 */

export function usePrevious(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}
export function useHideDocumentScrollBar(visible, isBody, mask) {
  useEffect(function () {
    var isChange = false;
    var previousDocumentOverflow = document.documentElement.style.overflow;

    if (visible && isBody && mask) {
      document.documentElement.style.overflow = 'hidden';
      isChange = true;
    }

    return function () {
      if (isChange) {
        document.documentElement.style.overflow = previousDocumentOverflow;
      }
    };
  }, [visible, isBody, mask]);
}
export function useOverflowHidden(container, hidden, allowDisable) {
  var needResetContainerStyle = useRef(false);
  var originContainerStyle = useRef({});

  var getScrollBarWidth = function getScrollBarWidth(element) {
    return element.tagName === 'BODY' ? window.innerWidth - (document.body.clientWidth || document.documentElement.clientWidth) : element.offsetWidth - element.clientWidth;
  };

  var setContainerStyle = function setContainerStyle() {
    if (container && container.style.overflow !== 'hidden') {
      var originStyle = container.style;
      needResetContainerStyle.current = true;
      var containerScrollBarWidth = getScrollBarWidth(container);

      if (containerScrollBarWidth) {
        var _context;

        originContainerStyle.current.width = originStyle.width;
        container.style.width = _concatInstanceProperty(_context = "calc(".concat(container.style.width || '100%', " - ")).call(_context, containerScrollBarWidth, "px)");
      }

      originContainerStyle.current.overflow = originStyle.overflow;
      container.style.overflow = 'hidden';
    }
  };

  var resetContainerStyle = function resetContainerStyle() {
    if (needResetContainerStyle.current && container) {
      var originStyle = originContainerStyle.current;

      _Object$keys(originStyle).forEach(function (i) {
        return container.style[i] = originStyle[i];
      });
    }

    needResetContainerStyle.current = false;
    originContainerStyle.current = {};
  };

  useEffect(function () {
    if (!allowDisable) return;
    hidden ? setContainerStyle() : resetContainerStyle();
    return function () {
      resetContainerStyle();
    };
  }, [container, hidden, allowDisable]);
  return [resetContainerStyle, setContainerStyle];
}
export function useResizeObserver(element, handler) {
  useEffect(function () {
    if (typeof element === 'function') {
      element = element();
    }

    if (!element) {
      devWarning(!element && element !== null, 'useResizeMeasure', 'useResizeMeasure指定的元素不存在');
      return;
    }

    var measure = function measure(entries) {
      if (!entries[0] || !entries[0].contentRect) {
        return;
      }

      var contentRect = entries[0].contentRect;
      var hide = contentRect.width === 0 && contentRect.height === 0; // 隐藏条件：高宽都为0
      // DOMRectReadOnly 对象不可读, 不可赋值

      var rect = _extends({
        hide: hide
      }, contentRect);

      ['width', 'height', 'x', 'y', 'bottom', 'top', 'left', 'right'].forEach(function (prop) {
        rect[prop] = contentRect[prop];
      });
      handler && handler(rect);
    };

    var resizeObserver = new ResizeObserver(measure);
    resizeObserver && resizeObserver.observe(element);
    return function () {
      resizeObserver && resizeObserver.disconnect();
    };
  }, [element, handler]);
}